<template lang="pug">
.d-flex.flex-column.gap-16.ga-4
  .d-flex.align-center(v-if="search")
    dv-text-field.flex-1.mr-2(
      v-model="searchKeys[search.filter]"
      :disabled="loading"
      v-bind="{ ...DEFAULT_SEARCH_ATTRS, ...search.attrs }"
      v-on="search.listeners"
      @keyup.enter="runSearch"
    )
    dv-btn.ui-primary.lighten-4(
      icon
      large
      :disabled="loading"
      @click="runSearch"
    ): v-icon(:size="20" color="ui-primary") $ui-search
  slot(name="search-field--filters" v-bind="{ filters, query, loading, method, searchKeys, runSearch }")
    .d-flex.align-center.gap-16.ga-4.flex-wrap(v-if="filters.length")
      slot(name="search-field--filters--prepend" v-bind="{ filters, query, loading, method, searchKeys, runSearch }")
      component(
        v-for="filterData in filters"
        :key="filterData.filter"
        :is="filterComponent(filterData)"
        :value="filterValue(filterData)"
        :disabled="loading || filterData?.attrs?.disabled || filterData?.component?.attrs?.disabled"
        v-bind="filterAttrs(filterData)"
        @input="(value) => handleFilterInput(value, filterData, runSearch)"
        v-on="filterData.listeners || filterData?.component?.listeners"
      )
      slot(name="search-field--filters--append" v-bind="{ filters, query, loading, method, searchKeys, runSearch }")

</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvMinifySelect from '@/packages/ui/components/inputs/DvMinifySelect.vue';
import DvTextField from '@/packages/ui/components/inputs/DvTextField.vue';

const DEFAULT_SEARCH_ATTRS = {
  outlined: false,
  solo: true,
  flat: true,
  height: 44,
  clearable: true,
  hideDetails: true,
};

export default {
  components: {
    DvTextField,
    DvBtn,
    DvMinifySelect,
  },
  props: {
    /** @SearchItem { filter: String, attrs: Object, listeners: Object } */
    search: { type: Object, default: null }, // SearchItem
    filters: { type: Array, default: () => ([]) }, // SearchItem[]
    query: { type: Object, default: () => ({}) },
    method: { type: Function, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      DEFAULT_SEARCH_ATTRS,
      searchKeys: { ...this.query },
    };
  },
  computed: {},
  watch: {
    searchKeys: {
      handler(val) {
        if (this.search && (!val[this.search.filter])) {
          this.runSearch();
        }
        this.$emit('update:query', val);
      },
      deep: true,
    },
    query: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.searchKeys)) {
          this.searchKeys = val;
        }
      },
    },
  },
  methods: {
    filterComponent(filterData) {
      return filterData?.component?.is || DvMinifySelect;
    },
    filterAttrs(filterData) {
      return filterData?.component?.attrs || filterData?.attrs || {};
    },
    filterValue(filterData) {
      if (filterData?.component?.mode === 'query') {
        return this.searchKeys;
      }
      return this.searchKeys[filterData.filter];
    },
    handleFilterInput(value, filterData, runSearch) {
      if (filterData?.component?.mode === 'query') {
        const { searchList = [] } = filterData;
        searchList.forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this.searchKeys, key)) {
            this.$delete(this.searchKeys, key);
          }
        });

        Object.entries(value || {}).forEach(([key, itemValue]) => {
          if (itemValue === undefined || itemValue === null || itemValue === '') {
            if (Object.prototype.hasOwnProperty.call(this.searchKeys, key)) {
              this.$delete(this.searchKeys, key);
            }
            return;
          }

          this.$set(this.searchKeys, key, itemValue);
        });
      } else if (value === undefined || value === null || value === '') {
        this.$delete(this.searchKeys, filterData.filter);
      } else {
        this.$set(this.searchKeys, filterData.filter, value);
      }

      runSearch();
    },
    runSearch() {
      if (this.loading) return;
      this.method(this.searchKeys);
    },
  },
};
</script>

<style lang="scss" scoped></style>
